import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../actions/getUserData";
import { setAppLoader } from "../../actions/setAppLoader";
import { saveFormPath } from "../../services/userService";
import ErrorModal from "../common/ErrorModal";
import CAlert from "../utils/CAlert";
import CButton from "../utils/CButton";
import { getEsignStatus, initiateEsign } from "../../services/avanseService";
import CircularLoader from "../utils/CircularLoader";

export default function AvanseEsignFlow({
  setTabValue,
  setStepperCount,
  userDetailId,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [PAN, setPAN] = React.useState("");
  const [aadhaar, setAadhaar] = React.useState("");
  const [isPANVerify, setIsPANVerify] = React.useState(false);
  const [isAadharVerify, setIsAadharVerify] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const params = new URLSearchParams(location.search);
  const userDetails = useSelector((state) => state?.getUserData?.data);
  const [isFetching, setIsFetching] = React.useState(true);
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userId = userData?.userId;
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [technicalError, setTechnicalError] = React.useState(false);
  const [verificationStatus, setVerificationStatus] = React.useState("PENDING");
  const disabledButton = verificationStatus !== "SUCCESS";
  const [pollingCount, setPollingCount] = React.useState(0);
  const [isPolling, setIsPolling] = React.useState(false);
  const [hasUserInitiated, setHasUserInitiated] = React.useState(false);
  const [vkycWebUrl, setVkycWebUrl] = React.useState("");
  const pollingIntervalRef = React.useRef(null);

  useEffect(() => {
    dispatch(getUserData(userDetailId || localStorage.getItem("detailId")));
  }, [dispatch, userDetailId]);

  useEffect(() => {
    const fetchEsignStatus = async () => {
      try {
        const status = await getEsignStatus(
          userDetailId || localStorage.getItem("detailId")
        );
        setVerificationStatus(status.response?.status);
        setVkycWebUrl(status.response?.esignWebLink);
        console.log("Esign status check:::::", status);
      } catch (error) {
        console.error("Error fetching E-sign status:", error);
      } finally {
        setIsFetching(false);
      }
    };

    if (userDetailId || localStorage.getItem("detailId")) {
      fetchEsignStatus();
    }
  }, [userDetailId]);

  const getVericationStatusMessage = (status) => {
    switch (status) {
      case "PENDING":
        return "Applicant E-Sign";
      case "INITIATE":
        return "Initiating E-Sign...";
      case "INITIATED":
        return "Initiating E-Sign...";
      case "IN_PROGRESS":
        if (!hasUserInitiated) {
          return "Resume E-Sign";
        }
        return "Processing E-Sign...";
      case "SUCCESS":
        return "E-Sign Completed";
      case "EXPPIRED":
        return "Re-Initiate E-Sign";
    }
  };

  const handleInitiateVkycSuccess = (link) => {
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      link = "https://" + link;
    }
    setVkycWebUrl(link);
    window.open(link, "_blank");
  };

  //Poll getLoanStatus API every 10 seconds
  React.useEffect(() => {
    if (!isPolling || verificationStatus === "PENDING") return;

    const pollLoanStatus = async () => {
      try {
        const response = await getEsignStatus(userDetailId);
        setPollingCount((prev) => prev + 1);
        setVerificationStatus(response.response?.status);
        setVkycWebUrl(response.response?.esignWebLink);
        console.log("Polling getLoanStatus response:", response);
        if (response?.response?.status === "SUCCESS") {
          setIsPolling(false);
          saveFormPath("/loanRepayment", userDetailId);
         
        } else if (response?.response?.status === "EXPIRED") {
          setIsPolling(false);
          setVerificationStatus("EXPIRED");
        }
      } catch (error) {
        console.error("Error polling loan status:", error);
        setPollingCount((prev) => prev + 1);
      }
    };

   pollingIntervalRef.current = setInterval(pollLoanStatus, 20000);

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [isPolling, userDetails, navigate, verificationStatus, userDetailId]);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [isFetching, dispatch]);

  React.useEffect(() => {
    if (verificationStatus === "failure") {
      setError(true);
      setErrorMsg("E-Sign Verification Failed, Please Try again");
    }
  }, [verificationStatus]);

  React.useEffect(() => {
    if (userDetails?.aadharDetails) {
      setAadhaar(userDetails.aadharDetails.aadharId);
      setIsAadharVerify(true);
      setVerificationStatus("VERIFIED");
    }
    if (userDetails?.userPanCardNumber) {
      setIsPANVerify(true);
      setPAN(userDetails?.userPanCardNumber);
    }
  }, [userDetails]);

  React.useEffect(() => {
    if (verificationStatus === "EXPIRED") {
      initiateVkycProcess();
    }
  }, [verificationStatus]);

  async function initiateVkycProcess() {
    if (!hasUserInitiated && verificationStatus === "IN_PROGRESS") {
      setHasUserInitiated(true);
      setTimeout(() => {
        handleInitiateVkycSuccess(vkycWebUrl);
      }, 1000);

      return;
    }
    if (verificationStatus !== "PENDING") {
      return;
    }
    setHasUserInitiated(true);
    setIsPolling(true);
    setVerificationStatus("INITIATE");
    initiateEsign(userDetailId).then((res) => {
      console.log("initiateDigilocker::::res", res);
      if (res?.success) {
        setVerificationStatus("INITIATED");
        setError(false);
        setErrorMsg("");
        setVkycWebUrl(res?.response?.link);
        handleInitiateVkycSuccess(res?.response?.link);
      } else {
        setTechnicalError(true);
      }
    });
  }

  // On Save and submit
  async function onSubmitVerified(e) {
    e.preventDefault();
    if (verificationStatus !== "SUCCESS") {
      setError(true);
      setErrorMsg("Please do E-Sign to proceed");
      return;
    }
    saveFormPath("/loanRepayment", userDetails?.detailId);
    dispatch(getUserData(userDetailId));
    setTabValue(6);
    navigate("/loanRepayment", {
      state: { tabValue: 6, stepperCount: 5, userDetailId: userDetailId },
    });
  }

  function handleBack() {
    navigate("/loanAgreement", {
      state: {
        tabValue: 3,
        stepperCount: 3,
        userDetailId: userDetailId || localStorage.getItem("detailId"),
      },
    });
  }

  function getPanOrAadhaarTemplate() {
    return renderEsignComponent();
  }

  function renderEsignComponent() {
    return (
      <>
        <Typography
          color="textColor"
          variant="h5"
          sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
        >
          Loan Agreement Signature
        </Typography>
        {verificationStatus === "SUCCESS" && (
            <Grid item justifyContent="center" style={{ display: "gird" }}>
              {verificationStatus === "SUCCESS" ? (
                <Typography
                  color="textColor"
                  variant="body2"
                  sx={{ textAlign: "center" }}
                >
                  E-Sign process completed successfully.
                </Typography>
              ) : (
                <Typography
                  color="textColor"
                  variant="body2"
                  sx={{ textAlign: "center" }}
                >
                  Click the above button to initiate E-Signature process.
                </Typography>
              )}
            </Grid>
          )}

        <Grid container rowSpacing={1} justifyContent="center">
          <Grid item xs={12} sm={8} md={6} className="digilocker-button">
            {verificationStatus !== "PENDING" &&
              verificationStatus !== "SUCCESS" &&
              hasUserInitiated && (
                <Grid item justifyContent="center" style={{ display: "grid" }}>
                  <CircularLoader></CircularLoader>
                </Grid>
              )}
            {verificationStatus === "IN_PROGRESS" && !hasUserInitiated && (
              <Grid item justifyContent="center" style={{ display: "gird" }}>
                <Typography
                  color="textColor"
                  variant="body2"
                  sx={{ textAlign: "center" }}
                >
                  Looks like you have initiated the agreement E-sign process
                  already. Please complete it by clicking on RESUME E-Sign
                  button.
                </Typography>
              </Grid>
            )}

            <CButton
              handleClick={initiateVkycProcess}
              variant={
                (verificationStatus === "PENDING" ||
                  verificationStatus === "IN_PROGRESS") &&
                !hasUserInitiated
                  ? "contained"
                  : "outlined"
              }
              name={getVericationStatusMessage(verificationStatus)}
              mt={4} // Adjust width as necessary
            />
          </Grid>
          

          {errorMsg && (
            <Grid item>
              <Typography
                color="textColor"
                variant="body2"
                sx={{ textAlign: "center", color: "red" }}
              >
                {errorMsg}
              </Typography>
            </Grid>
          )}
        </Grid>
        <div
          style={{
            pt: 12,
            padding: "100px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: `${!matches ? "space-around" : "space-between"}`,
          }}
        >
          {matches && (
            <CButton
              handleClick={() => handleBack()}
              name="Back"
              variant="outlined"
            />
          )}
          <Button
            type="submit"
            sx={{ fontStyle: "Lato" }}
            color="neutral"
            disabled={disabledButton}
            variant="contained"
          >
            Save & Submit
          </Button>
        </div>
      </>
    );
  }

  return (
    <form
      onSubmit={(e) => onSubmitVerified(e)}
      className="applicationFormContainer"
    >
      {error && <CAlert open={error} message={errorMsg} severity="error" />}

      {!matches && (
        <Box sx={{ display: "flex" }}>
          <ArrowBackIosIcon onClick={() => handleBack()} />
        </Box>
      )}

      {getPanOrAadhaarTemplate()}

      {technicalError && (
        <ErrorModal
          open={technicalError}
          setOpen={setTechnicalError}
          isTechnicalError={true}
        />
      )}
    </form>
  );
}
